import Vue from 'vue';
import VueRouter, { RawLocation } from 'vue-router';
import { logout } from '@/useable/login';
import { session } from '@utils/storage';

// 寻找父级 构建层级关系
const setRoutes = (route, parent, repeat = false) => {
  route.children = route.children || [];
  const child = parent.find(parentRoute => (parentRoute.name === route.name));
  if (child) {
    if (repeat) {
      child.component = route.component;
      child.meta = route.meta;
    }
    parent = child.children;
  } else {
    parent.push(route);
    parent = route.children;
  }
  return parent;
};
// 根据配置文件设置meta等信息
const setConfig = (configFiles, configKeys, configPath, route) => {
  if (configKeys.includes(configPath)) {
    const config = configFiles(configPath).routeConfig;
    route.meta = config?.meta ? config.meta : {};
    if (config?.params) {
      route.path = `${route.path}/${config.params}`;
    }
    if (config?.redirect) {
      route.redirect = config.redirect;
    }
  }
};
// 从父级向下找寻组件
const restructure = (routes) => {
  for (const route of routes) {
    const { children } = route;
    if (!route.component && children?.length > 0) {
      for (let j=0; j<children.length; j++) {
        const childRoute = children[j];
        if (childRoute.name === route.name || childRoute.name === 'Index' || childRoute.name === 'Home') {
          if (childRoute.name === route.name) childRoute.path = `/${childRoute.path}`;
          route.meta = childRoute.meta;
          route.component = childRoute.component;
          if (childRoute.redirect) route.redirect = childRoute.redirect;
          children.splice(j, 1);
          break;
        }
      }
      if (!route.component) {
        route.component = children[0].component;
        route.meta =children[0].meta;
        if (children[0].redirect) route.redirect = children[0].redirect;
      }

    }
    if (children?.length > 0) {
      route.children = restructure(route.children);
    }
  }
  return routes;
};
// 根据目录创建路由
const createRoutes = (rootRedirect='') => {
  const routes: any = [];
  const views = (require as any).context('@/views', true, /\.vue/);
  const configFiles = (require as any).context('@/views', true, /\.ts/);

  // 将路径进行排序，保证层级正确
  let viewsKeys = views.keys();
  viewsKeys = viewsKeys.sort((a, b) => {
    return a.length - b.length;
  });
  const configKeys = configFiles.keys();

  // 遍历路径
  viewsKeys.forEach((view) => {
    const str = view.replace(/^.\//, '');
    const keys = str.split('/');
    // 每次遍历，将父路由初始化为最外层级
    let parent: Array<any> = routes;
    // 遍历文件层级
    keys.forEach((key, index) => {
      // 路由初始化
      const route: any = {
        name: '',
        path: ''
      };

      route.path = (index > 0 ? key.replace(key[0], key[0].toLowerCase()) : `/${key.replace(key[0], key[0].toLowerCase())}`).replace('.vue', '');
      route.name = key.replace(key[0], key[0].toUpperCase()).replace('.vue', '');
      const PATH = keys.slice(0, index+1).join('/');

      if (key.includes('.vue') && key.toLowerCase() !== 'index.vue') {
        route.component = () => import(`@/views/${PATH}`);
        setConfig(configFiles, configKeys, `./${PATH.replace('.vue', '')}.ts`, route);
        parent = setRoutes(route, parent);
      } else if (keys.length === 1 && key.toLowerCase() === 'index.vue') {
        route.path = '/';
        route.component = () => import(`@/views/${key}`);
        route.meta = { title: '首页' };
        setConfig(configFiles, configKeys, `./${key.replace('.vue', '')}.ts`, route);
        parent = setRoutes(route, parent);
        if (rootRedirect) {
          route.redirect = rootRedirect;
        }
      } else if (viewsKeys.includes(`./${PATH}/index.vue`)) {
        route.component = () => import(`@/views/${PATH}/index.vue`);
        setConfig(configFiles, configKeys, `./${PATH.replace('.vue', '')}/index.ts`, route);
        parent = setRoutes(route, parent, true);
      } else if (key.toLowerCase() !== 'index.vue'){
        parent = setRoutes(route, parent);
      }
    });
  });

  const rootPath = routes.find(route => route.path === '/');
  if (!rootPath) {
    const temp: any = {
      path: '/',
      name: 'Index',
      meta: {
        title: '首页'
      },
    };
    if (rootRedirect) {
      temp.redirect = rootRedirect;
    }
    routes.push(temp);
  }
  
  return restructure(routes);
};

// 路由地址`/` 重定向到门户页`/portal`
const routes = createRoutes('/portal');

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: RawLocation) {
  return (originalPush.call(this, location) as any).catch((err: any) => err);
};

Vue.use(VueRouter);


const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  // 进入登录、注册、密码重置和门户页，不验证用户登录状态
  if (to.path.includes('/login') || to.path.includes('/portal') || to.path.includes('/openSoftware') || to.path.includes('/pdf')) {
    next();
  } else {
    const { expires } = session.get('user-infor', true) || {expires: null};
    if (!expires) {
      (async () => {
        await logout();
      })();
      next('/login');
    } else {
      next();
    }
  }
});

export default router;
